import React from 'react'

/**
 * Full-page back navigation.
 * - `sidebar`: text link in BusinessSidebar when the sidebar is visible.
 * - `panel` (default): button in the main column when the sidebar is hidden.
 */
const PageBackLink = ({ url, label, variant = 'panel' }) => {
  if (variant === 'sidebar') {
    return (
      <a
        href={url}
        className="inline-flex items-center gap-2 text-sm font-medium text-surface"
      >
        <hero-icon-solid name="arrow-left" class="h-3.5 w-3.5 shrink-0 pointer-events-none" />
        <span>{`Back to ${label}`}</span>
      </a>
    )
  }

  return (
    <a
      href={url}
      className="btn-neutral btn-base-extra-small"
    >
      <hero-icon-solid name="arrow-left" class="h-3 w-3 pointer-events-none" />
      <span>{`Back to ${label}`}</span>
    </a>
  )
}

export default PageBackLink
